<template>
    <div class="bg">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span style="font-weight:bold;font-size:24px">构建系统登录</span>
            </div>
            <el-form :model="user" status-icon :rules="rules" ref="user" label-width="100px" class="demo-ruleForm">
                <el-form-item label-width="0px" prop="userName">
                    <el-input type="text" placeholder="用户名" v-model="user.userName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label-width="0px" prop="password">
                    <el-input type="password" placeholder="密码" v-model="user.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label-width="0px">
                    <el-button type="primary"  @keyup.enter.native="enterLogin" @click="login('user')">登录</el-button>
                </el-form-item>
            </el-form>
            
            <el-link style="float:left; color:red;" class="flowText" href="http://www.bt-lab.cn/cn/info_208.aspx?itemid=226" target="_blank">流程说明</el-link>
            <el-link style="float:right; color:red;" class="addQq" type="primary" @click="addQq">加入QQ福利群</el-link>
            <!-- <el-link style="float:right; color:red;" class="addQq" href="https://qm.qq.com/cgi-bin/qm/qr?k=BN4jT3uvuQNYQlknxi1qFnPx9Sxab7-M&jump_from=webapi&authKey=wf7y4GIiNwGhQdbf/Lieycarc0tHAYqFz70Ood2UN+YRVr8jmnFaf7B6icQegtQ+" target="_blank">加入QQ福利群</el-link> -->
        </el-card>
    </div>
</template>

<script>
    import globeCommon from '../assets/js/GlobeCommon.js'

    export default {
        name:'Login',
        data() {
            return {
                user:{
                    userName:"",
                    password:""
                },
                rules: {
                    userName: [
                        { required: true, message: "请输QQ号", trigger: "blur" },
                        { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                        { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                    ],
                    
                },
            }
        },
        methods: {
            login(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post("/login/login",this.user).then(
                            res=>{
                                if(res.data.status === "success"){
                                    window.localStorage.setItem("user",JSON.stringify(res.data.result));
                                    this.user = JSON.parse(window.localStorage.getItem("user"));
                                    globeCommon.userId = this.user.userId;
                                    window.localStorage.setItem("userId",this.user.userId);
                                    window.sessionStorage.setItem("isLogin", true);
                                    // this.$router.push("/mobile/myOrderInfo");
                                    if(this.user.roleCode === 'SUPER') {
                                        this.$router.push("/mobile/orderInfo");
                                    } else if(this.user.roleCode === 'ADMIN') {
                                        this.$router.push("/mobile/orderInfo");
                                    } else if (this.user.roleCode === 'AGENT') {
                                        this.$router.push("/mobile/groupOrderInfo");
                                    } else if(this.user.roleCode === 'RESPONSIBLE') {
                                        this.$router.push("/mobile/groupOrderInfo");
                                        // this.$router.push("/mobile/myOrderInfo");
                                    } else {
                                        this.$router.push("/mobile/myOrderInfo");
                                    }

                                } else {
                                    this.$message.error(res.data.message);
                                }
                            },
                            error=>{
                                this.$message.error(error.message);
                            }
                        )
                    } else {
                        return false;
                    }
                });

                
            },
            enterLogin(){
                document.onkeydown =(e) => {
                    e = window.event || e;
                    if(e.code=='Enter'||e.code=='enter'){
                        //调用登录事件方法
                        this.login('user');
                    }
                }
            },
            addQq() {
                window.open("https://qm.qq.com/cgi-bin/qm/qr?k=BN4jT3uvuQNYQlknxi1qFnPx9Sxab7-M&jump_from=webapi&authKey=wf7y4GIiNwGhQdbf/Lieycarc0tHAYqFz70Ood2UN+YRVr8jmnFaf7B6icQegtQ+");
            }
        },
        created() {
            this.enterLogin();
        },
        
    }


</script>

<style scoped>

    .text {
        font-size: 14px;
    }

    .item {
        padding: 18px 0;
    }

    .box-card {
        width: 80%;
        /* position:absolute; */
        margin-top: 40%;
        margin-left: 10%;
    }
    .bg {
        width: 100%;
        height: 100%;
        position: fixed;
        background: url("~@/assets/loginImageMobile.jpg");
        background-size: 100% 100%;
    }
    .el-button {
        width:100%;
    }
    .flowText {
        margin-left: 20px;
        margin-bottom: 10px;
    }

</style>
